// vaccinationData.js
export const vaccinationData = [
    {
      "age": "Birth - 2 Months",
      "vaccines": [
        { "name": "Hepatitis B (HepB)", "dose": "1st dose" },
        { "name": "Diphtheria, Tetanus, Pertussis (DTaP)", "dose": "1st dose" },
        { "name": "Haemophilus influenzae type b (Hib)", "dose": "1st dose" },
        { "name": "Polio (IPV)", "dose": "1st dose" },
        { "name": "Pneumococcal Conjugate (PCV13)", "dose": "1st dose" },
        { "name": "Rotavirus (RV)", "dose": "1st dose" }
      ]
    },
    {
      "age": "2 Months",
      "vaccines": [
        { "name": "Hepatitis B (HepB)", "dose": "2nd dose" },
        { "name": "Diphtheria, Tetanus, Pertussis (DTaP)", "dose": "2nd dose" },
        { "name": "Haemophilus influenzae type b (Hib)", "dose": "2nd dose" },
        { "name": "Polio (IPV)", "dose": "2nd dose" },
        { "name": "Pneumococcal Conjugate (PCV13)", "dose": "2nd dose" },
        { "name": "Rotavirus (RV)", "dose": "2nd dose" }
      ]
    },
    {
      "age": "4 Months",
      "vaccines": [
        { "name": "Diphtheria, Tetanus, Pertussis (DTaP)", "dose": "3rd dose" },
        { "name": "Haemophilus influenzae type b (Hib)", "dose": "3rd dose" },
        { "name": "Polio (IPV)", "dose": "3rd dose" },
        { "name": "Pneumococcal Conjugate (PCV13)", "dose": "3rd dose" },
        { "name": "Rotavirus (RV)", "dose": "3rd dose" }
      ]
    },
    {
      "age": "6 Months",
      "vaccines": [
        { "name": "Diphtheria, Tetanus, Pertussis (DTaP)", "dose": "4th dose" },
        { "name": "Haemophilus influenzae type b (Hib)", "dose": "4th dose (if needed)" },
        { "name": "Polio (IPV)", "dose": "4th dose" },
        { "name": "Pneumococcal Conjugate (PCV13)", "dose": "4th dose" },
        { "name": "Rotavirus (RV)", "dose": "4th dose (if needed)" },
        { "name": "Influenza (Flu)", "dose": "Annual vaccination starts" }
      ]
    },
    {
      "age": "12-15 Months",
      "vaccines": [
        { "name": "MMR (Measles, Mumps, Rubella)", "dose": "1st dose" },
        { "name": "Haemophilus influenzae type b (Hib)", "dose": "Booster dose (if needed)" },
        { "name": "Pneumococcal Conjugate (PCV13)", "dose": "Booster dose (if needed)" },
        { "name": "Varicella (Chickenpox)", "dose": "1st dose" },
        { "name": "Hepatitis A (HepA)", "dose": "1st dose" },
        { "name": "Influenza (Flu)", "dose": "Annual vaccination" }
      ]
    },
    {
      "age": "15-18 Months",
      "vaccines": [
        { "name": "Diphtheria, Tetanus, Pertussis (DTaP)", "dose": "5th dose" },
        { "name": "Hepatitis A (HepA)", "dose": "2nd dose" }
      ]
    },
    {
      "age": "4-6 Years",
      "vaccines": [
        { "name": "Diphtheria, Tetanus, Pertussis (DTaP)", "dose": "6th dose (final dose)" },
        { "name": "Polio (IPV)", "dose": "5th dose (final dose)" },
        { "name": "MMR (Measles, Mumps, Rubella)", "dose": "2nd dose" },
        { "name": "Varicella (Chickenpox)", "dose": "2nd dose" },
        { "name": "Influenza (Flu)", "dose": "Annual vaccination" }
      ]
    },
    {
      "age": "11-12 Years",
      "vaccines": [
        { "name": "Tdap (Tetanus, Diphtheria, Pertussis)", "dose": "1st dose" },
        { "name": "HPV (Human Papillomavirus)", "dose": "1st dose (2-dose series for ages 11-14 or 3-dose series for ages 15-26)" },
        { "name": "Meningococcal Conjugate (MenACWY)", "dose": "1st dose" },
        { "name": "Influenza (Flu)", "dose": "Annual vaccination" }
      ]
    },
    {
      "age": "Additional at any age",
      "vaccines": [
        { "name": "Vaccine not in the list", "dose": "does NA" }
      ]
    }
  ];
  